window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  document.addEventListener(
    "shopify:section:load",
    this._onSectionLoad.bind(this)
  );
  document.addEventListener(
    "shopify:section:unload",
    this._onSectionUnload.bind(this)
  );
  document.addEventListener(
    "shopify:section:select",
    this._onSelect.bind(this)
  );
  document.addEventListener(
    "shopify:section:deselect",
    this._onDeselect.bind(this)
  );
  document.addEventListener(
    "shopify:block:select",
    this._onBlockSelect.bind(this)
  );
  document.addEventListener(
    "shopify:block:deselect",
    this._onBlockDeselect.bind(this)
  );
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var id = container.getAttribute("data-section-id");
    var type = container.getAttribute("data-section-type");

    constructor = constructor || this.constructors[type];

    if (typeof constructor === "undefined") {
      return;
    }

    var instance = Object.assign(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = document.querySelector(
      '[data-section-id="' + evt.detail.sectionId + '"]'
    );

    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    this.instances = this.instances.filter(function (instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (typeof instance.onUnload === "function") {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onSelect === "function"
    ) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onDeselect === "function"
    ) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockSelect === "function"
    ) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockDeselect === "function"
    ) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
      function (container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

theme.collectionSlider = (function () {
  function sliderProduct(e) {
    let sliderContainer = "",
      extraLargeDesktopShow = 4,
      largeDesktopShow = 3,
      tabletShow = 3,
      mobileShow = 2,
      sliderRows = parseInt(e.dataset.sliderRows),
      sliderGrid = "column",
      sliderLoop = e.dataset.loop;

    if (sliderLoop === "true") {
      sliderLoop = true;
    } else {
      sliderLoop = false;
    }

    if (sliderRows > 1) {
      sliderGrid = "row";
      sliderLoop = false;
    }
    if (e.dataset.sliderEnable === "true") {
      sliderContainer = e.querySelector(".productSlider");
      extraLargeDesktopShow = parseInt(e.dataset.showExtraLarge);
      largeDesktopShow = parseInt(e.dataset.showLarge);
      tabletShow = parseInt(e.dataset.showTablet);
      mobileShow = parseInt(e.dataset.showMobile);
    }

    var swiper = new Swiper(sliderContainer, {
      loop: sliderLoop,
      slidesPerView: mobileShow,
      spaceBetween: 20,
      grid: {
        rows: sliderRows,
        fill: sliderGrid,
      },
      pagination: {
        el: e.querySelector(".swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: e.querySelector(".product_slider_wrapper .swiper-button-next"),
        prevEl: e.querySelector(".product_slider_wrapper .swiper-button-prev"),
      },
      breakpoints: {
        640: {
          slidesPerView: mobileShow,
        },
        750: {
          slidesPerView: tabletShow,
        },
        992: {
          slidesPerView: largeDesktopShow,
        },
        1200: {
          slidesPerView: extraLargeDesktopShow,
        },
      },
    });
    // Slide thumbnail height
    const slideThumbHeight = () => {
      const proudctThumbnails = e.querySelectorAll(".card--client-height");
      if (proudctThumbnails.length > 0) {
        const productThumbnailHeight = proudctThumbnails[0];
        e.style.setProperty(
          "--slider-navigation-top-offset",
          `${productThumbnailHeight.clientHeight / 2}px`
        );
      }
    };
    slideThumbHeight();
    window.addEventListener("resize", () => {
      slideThumbHeight();
    });
  }
  return sliderProduct;
})();

document.addEventListener("DOMContentLoaded", function () {
  let sections = new theme.Sections(),
    headerSearchModule = new theme.Sections(),
    headerCartModule = new theme.Sections(),
    headerStickyModule = new theme.Sections();

  sections.register("announcement-bar", theme.announcement);
  sections.register("header", theme.headerSection);
  sections.register("header", theme.headerCategoryMenu);
  headerSearchModule.register("header", theme.headerSearch);
  headerStickyModule.register("header", theme.headerSticky);
  sections.register("footer", theme.footerSection);
  sections.register("slideShow", theme.SlideShow);
  sections.register("product-tab", theme.productTab);
  sections.register("collection-product", theme.collectionProduct);
  sections.register("product-slider", theme.collectionSlider);
  sections.register("counter_up", theme.counterup);
  sections.register("faq-collapse", theme.accordion);
  sections.register("popup-video", theme.video);
  sections.register("lookbook", theme.lookbookSlider);
  sections.register("timeline", theme.timelineSlider);
});



// new adding - FIXED
document.addEventListener("DOMContentLoaded", function() {
  const newSlider = document.querySelector('.collection-slider');
  // Check if the element exists AND if the function exists
  if (newSlider && window.theme && theme.collectionSlider) {
    theme.collectionSlider(newSlider);
  }
});


  document.addEventListener('DOMContentLoaded', function() {
    const menuItems = document.querySelectorAll('.header__menu_li');

    menuItems.forEach(item => {
      // Only target items that have the 'has-sub-menu' trigger
      const trigger = item.querySelector('.header__menu_item.has-sub-menu');
      
      if (trigger) {
        trigger.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const isOpen = item.classList.contains('is-open');

          // Close all others
          menuItems.forEach(mi => mi.classList.remove('is-open'));

          // Toggle current
          if (!isOpen) {
            item.classList.add('is-open');
          }
        });
      }
    });

    // Close when clicking outside
    document.addEventListener('click', function() {
      menuItems.forEach(item => item.classList.remove('is-open'));
    });
  });




(function() {
  const initShowMore = () => {
    // We use a class instead of ID to avoid Liquid variable issues in JS
    const content = document.querySelector('#product_all .js-description-content');
    const btn = document.querySelector('#product_all .description-toggle-btn');
    
    // Check if both elements exist before doing anything
    if (!content || !btn) return;

    // Reset visibility logic
    if (content.scrollHeight > 210) { 
      btn.style.setProperty('display', 'inline-block', 'important');
    }

    // Single click listener
    btn.onclick = function() {
      const isTruncated = content.classList.contains('is-truncated');
      if (isTruncated) {
        content.classList.remove('is-truncated');
        content.classList.add('is-expanded');
        this.innerText = 'Show Less';
      } else {
        content.classList.add('is-truncated');
        content.classList.remove('is-expanded');
        this.innerText = 'Show More';
        content.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };
  };

  // Run on initial load
  document.addEventListener('DOMContentLoaded', initShowMore);
  
  // Run when tabs are clicked (in case description was hidden/0px height initially)
  document.querySelectorAll('.product_tab_list__li').forEach(tab => {
    tab.addEventListener('click', () => setTimeout(initShowMore, 200));
  });
})();


// mew
(function () {
  let isAdding = false;

  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.boost-sd__button--select-option--');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    if (isAdding) return;
    isAdding = true;

    try {
      const metadata = JSON.parse(btn.getAttribute('data-metadata') || '{}');
      console.log('[ATC] metadata: --', metadata);

      if (metadata?.action?.addToCart) {
        const atc = metadata.action.addToCart;
        const variantId = atc.variantId || atc.productId || atc.id;
        if (!variantId) throw new Error('No variant id found');

        // Request the EXACT sections this theme's cart-notification expects
        const body = {
          items: [{
            id: variantId,
            quantity: 1,
            ...(atc.selling_plan && { selling_plan: atc.selling_plan })
          }],
          sections: 'mini-cart-drawer,cart-notification-count,cart-icon-bubble',
          sections_url: window.location.pathname
        };

        console.log('[ATC] posting:', body);

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(body)
        });

        const data = await res.json().catch(() => ({}));
        console.log('[ATC] response:', res.status, 'sections:', data.sections && Object.keys(data.sections));

        if (!res.ok) throw new Error(data.description || data.message || `HTTP ${res.status}`);

        // Hand off to the theme's own cart-notification controller
        const cartNotification = document.querySelector('cart-notification');
        if (cartNotification && typeof cartNotification.renderContents === 'function') {
          cartNotification.renderContents(data);
          console.log('[ATC] ✓ renderContents() called');
        } else {
          console.warn('[ATC] renderContents unavailable — using fallback');
          fallbackRender(data);
        }

        // Update the header cart count bubble separately (not handled by renderContents)
        updateCartBubble(data);

        // Log full cart for sanity
        const cart = await fetch('/cart.js').then(r => r.json());
        console.log('[ATC] cart now:', cart.item_count, 'items');
      }
      else if (metadata?.action?.quickAddToCart || metadata?.action?.quickView) {
        const productId =
          metadata.action.quickAddToCart?.productId ||
          metadata.action.quickView?.productId;
        window.location.href = `/products/${productId}`;
      }
      else {
        window.location.href = btn.closest('a')?.href || '#';
      }
    } catch (err) {
      console.error('[ATC] ERROR:', err);
      alert('Add to cart failed: ' + err.message);
    } finally {
      isAdding = false;
    }
  }, true);

  // ============================================================
  // UPDATE HEADER CART BUBBLE
  // ============================================================
  function updateCartBubble(data) {
    const bubbleHtml = data.sections?.['cart-icon-bubble'];
    if (!bubbleHtml) return;

    const doc = new DOMParser().parseFromString(bubbleHtml, 'text/html');
    const freshBubble =
      doc.querySelector('.cart-count-bubble') ||
      doc.querySelector('[class*="cart_num" i]') ||
      doc.body.firstElementChild;
    let currentBubble = document.querySelector('.cart-count-bubble, .header__actions_btn_cart_num');

    if (freshBubble && currentBubble) {
      currentBubble.innerHTML = freshBubble.innerHTML;
    } else if (freshBubble) {
      const cartLink = document.querySelector('.header__actions_btn--cart, [href="/cart"]');
      if (cartLink) {
        const wrapper = document.createElement('div');
        wrapper.className = 'cart-count-bubble header__actions_btn_cart_num';
        wrapper.innerHTML = freshBubble.innerHTML;
        cartLink.appendChild(wrapper);
      }
    }
  }

  // ============================================================
  // FALLBACK — matches the theme's own render logic by hand
  // ============================================================
  function fallbackRender(data) {
    const drawer = document.getElementById('mini-cart-drawer');
    if (!drawer) return;

    // Replicate getSectionInnerHTML: parse and pull from .shopify-section
    const getInner = (html) => {
      try {
        return new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('.shopify-section')?.innerHTML || '';
      } catch { return ''; }
    };

    const drawerHtml = data.sections?.['mini-cart-drawer'];
    if (drawerHtml) {
      const inner = getInner(drawerHtml);
      if (inner) drawer.innerHTML = inner;
    }

    const mobileCount = document.getElementById('cart-notification-count-mobile');
    const countHtml = data.sections?.['cart-notification-count'];
    if (mobileCount && countHtml) {
      mobileCount.innerHTML = getInner(countHtml);
    }

    // Open the drawer the theme's way
    drawer.classList.add('animate', 'active');
    document.body.classList.add('added__overlay');
  }
})();